<template>
  <div class="live-dashboard vh-100 d-flex flex-column mt-n2">
    <b-row
      align-content="center"
      match-height
    >
      <b-col
        cols="12"
        md="3"
      >
        <counter-card
          title-text="Aylık Ciro"
          sub-title-text="MTD"
          :value-data="dashboardData.counters.mtdTurnover | toNumber"
          color-class="success"
          prefix-text=""
          suffix-text="₺"
          icon-name="ActivityIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <counter-card2
          title-text="İş Emirleri"
          sub-title-text="Açık / Kapalı"
          :value-data="dashboardData.counters.serviceWorks.open | toNumber"
          :value2-data="dashboardData.counters.serviceWorks.closed | toNumber"
          color-class="warning"
          prefix-text=""
          suffix-text="Adet"
          prefix2-text=""
          suffix2-text="Adet"
          icon-name="ActivityIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <counter-card
          title-text="Araç Girişi"
          sub-title-text="MTD"
          :value-data="dashboardData.counters.mtdCount | toNumber"
          color-class="info"
          prefix-text=""
          suffix-text="Adet"
          icon-name="SettingsIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <counter-card
          title-text="Ortalama Teknisyen Süresi"
          sub-title-text="İş Emri Başına"
          :value-data="dashboardData.counters.serviceWorkDurationAVG | toNumber"
          color-class="danger"
          prefix-text=""
          suffix-text="Saat"
          icon-name="ClockIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
    </b-row>
    <b-row
      align-content="center"
      match-height
    >
      <b-col
        cols="12"
        md="5"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Aylık Servis Araç Girişi Trendi"
            card-sub-title="YTD"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="yearlyCount"
          />
          <div
            v-if="loadings.yearlyCount"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <area-charts
              v-if="dashboardData.yearlyCount.series.length"
              :series-data="dashboardData.yearlyCount.series"
              :categories-data="dashboardData.yearlyCount.categories"
              chart-height="250"
            />
          </template>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Marka Bazlı Araç Girişi"
            card-sub-title="MTD"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="brandsCount"
          />
          <div
            v-if="loadings.brandsCount"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <pie-charts
              v-if="dashboardData.brandsCount.series.length"
              :series-data="dashboardData.brandsCount.series"
              :labels-data="dashboardData.brandsCount.labels"
              :colors-data="dashboardData.brandsCount.colors"
            />
          </template>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Marka Bazlı Servis Kapasite"
            card-sub-title="MTD"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="brandsWorks"
          />
          <div
            v-if="loadings.brandsWorks"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <bar-with-markers
              v-if="dashboardData.brandsWorks.series.length"
              :series-data="dashboardData.brandsWorks.series"
            />
          </template>
        </b-card>
      </b-col>
    </b-row>
    <b-row
      align-content="center"
      match-height
    >
      <b-col
        cols="12"
        md="4"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Açık İş Emirleri"
            card-sub-title="Marka Bazlı"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="brandsDayWorks"
          />
          <div
            v-if="loadings.brandsDayWorks"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <stacked-bar-charts
              :series-data="dashboardData.brandsDayWorks.series"
              :categories-data="dashboardData.brandsDayWorks.categories"
              :colors-data="dashboardData.brandsDayWorks.colors"
            />
          </template>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Servis Ciro Dağılımı %"
            card-sub-title="MTD"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="serviceTurnovers"
          />
          <div
            v-if="loadings.serviceTurnovers"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <pie-charts
              v-if="dashboardData.serviceTurnovers.series.length"
              :series-data="dashboardData.serviceTurnovers.series"
              :labels-data="dashboardData.serviceTurnovers.labels"
              :colors-data="dashboardData.serviceTurnovers.colors"
            />
          </template>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="5"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Servis Departmanı Hedef"
            card-sub-title="MTD"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="serviceGoals"
          />
          <div
            v-if="loadings.serviceGoals"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <table-goals :data-list="dashboardData.serviceGoals" />
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BRow, BCol, BCard, BButton,
} from 'bootstrap-vue'
import PreLoading from '@/layouts/components/Loading.vue'
import CounterCard from '@/views/Dashboard/Live/Components/CounterCard.vue'
import CounterCard2 from '@/views/Dashboard/Live/Components/CounterCard2.vue'
import CardCustomHeader from '@/views/Dashboard/Live/Components/CardCustomHeader.vue'
import AreaCharts from '@/views/Dashboard/Live/Charts/AreaCharts.vue'
import PieCharts from '@/views/Dashboard/Live/Charts/PieCharts.vue'
import StackedBarCharts from '@/views/Dashboard/Live/Charts/StackedBarCharts.vue'
import BarWithMarkers from '@/views/Dashboard/Live/Charts/BarWithMarkers.vue'
import TableGoals from '@/views/Dashboard/Live/ServiceDashboard/TableGoals.vue'

export default {
  name: 'ServiceDashboard',
  components: {
    BarWithMarkers,
    StackedBarCharts,
    PieCharts,
    AreaCharts,
    CardCustomHeader,
    CounterCard2,
    CounterCard,
    TableGoals,
    BRow,
    BCol,
    BCard,
    BButton,
    PreLoading,
  },
  data() {
    return {
      intervalId: null,
    }
  },
  computed: {
    loadings() {
      return this.$store.getters['liveServiceDashboard/loadings']
    },
    dashboardData() {
      return this.$store.getters['liveServiceDashboard/dashboardData']
    },
    cacheInfo() {
      return this.$store.getters['liveServiceDashboard/cacheInfo']
    },
    configData() {
      return this.$store.getters['liveDashboardConfig/configData']
    },
  },
  mounted() {
    this.startCountdown()
  },
  created() {
    this.getDashboard()
  },
  methods: {
    startCountdown() {
      if (this.configData.refreshTime !== false) {
        this.intervalId = setInterval(() => {
          this.refreshDashboard()
        }, this.configData.refreshTime)
      }
    },
    getDashboard() {
      this.getData('counters')
      this.getData('yearlyCount')
      this.getData('brandsCount')
      this.getData('brandsWorks')
      this.getData('brandsDayWorks')
      this.getData('serviceTurnovers')
      this.getData('serviceGoals')
    },
    refreshDashboard() {
      this.$store.commit('liveServiceDashboard/RESET_DASHBOARD_DATA')
      this.refreshData('counters')
      this.refreshData('yearlyCount')
      this.refreshData('brandsCount')
      this.refreshData('brandsWorks')
      this.refreshData('brandsDayWorks')
      this.refreshData('serviceTurnovers')
      this.refreshData('serviceGoals')
    },
    getData(type) {
      this.$store.dispatch('liveServiceDashboard/getData', { type })
    },
    refreshData(type) {
      this.$store.dispatch('liveServiceDashboard/refreshData', { type })
    },
  },
}
</script>
<style scoped>
.card-small .card-body{
  padding: 10px !important;
}
.card-fixed{
  overflow: hidden;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
